import React, { useState, useEffect } from 'react';
import {
    Container,
    Tile,
    SelectorContainer,
    Selector,
    SelectorText,
} from './styles';
import { maskedYearStart } from 'utils/date/constants';
import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';

const YearMonthSelector = ({
    showModal,
    setShowModal,
    monthOptions,
    activeMonth,
    setActiveMonth,
    activeYear,
    setActiveYear,
    yearOptions,
}) => {
    const [selector, setSelector] = useState('year');
    const [selectedMonth, setSelectedMonth] = useState(activeMonth);
    const [selectedYear, setSelectedYear] = useState(activeYear);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    if (selectedYear.toString() === currentYear.toString()) {
        monthOptions = monthOptions.filter(
            (item) => (item.value as number) - 1 <= currentMonth
        );
    }

    useEffect(() => {
        if (
            selectedYear === currentYear &&
            monthOptions.findIndex((month) => month.name === selectedMonth) ===
                -1
        ) {
            setActiveMonth('Jan');
            setSelectedMonth('Jan');
        }
    }, [showModal, selectedYear]);

    useEffect(() => {
        showModal && setSelector('year');
    }, [showModal]);

    const displayMonth = monthOptions.filter(
        (month) => month.name === selectedMonth
    )[0]?.displayName;

    const months = monthOptions.map((month) => {
        return (
            <Tile
                key={month.value}
                selected={month.name === selectedMonth}
                onClick={() => {
                    setSelectedMonth(month.name);
                    setActiveMonth(month.name);
                    selectedYear !== '' && setShowModal(false);

                    // setRecentMonthTileClick(true);
                    // yearIndex !== undefined ? setShowModal(false) : setSelector("year");
                }}
            >
                {month.name}
            </Tile>
        );
    });

    const years = yearOptions.map((year) => {
        return (
            <Tile
                key={year.value}
                selected={year.name === selectedYear}
                onClick={() => {
                    setActiveYear(year.name);
                    setSelectedYear(year.name);
                    if (year.name !== `Before ${maskedYearStart}`)
                        setSelector('month');
                    else {
                        setShowModal(false);
                        setActiveMonth('Jan');
                    }
                    // recentMonthTileClick ? setShowModal(false) : setSelector("month");
                }}
            >
                {year.name}
            </Tile>
        );
    });

    return (
        <>
            <div>
                <>
                    <SelectorContainer>
                        <Selector
                            onClick={() => {
                                setSelector('year');
                            }}
                            selected={selector === 'year'}
                        >
                            <SelectorText selected={selector === 'year'}>
                                {selectedYear || 'Year'}
                            </SelectorText>
                            <Image
                                style={{
                                    cursor: 'pointer',
                                    transform:
                                        selector === 'year'
                                            ? 'rotate(180deg)'
                                            : 'rotate(0deg)',
                                    transitionDuration: '100ms',
                                }}
                                src={getImageBasePath('/icons/arrow.svg')}
                                width={'12px'}
                                height={'12px'}
                            />
                        </Selector>
                        <Selector
                            onClick={() => {
                                setSelector('month');
                            }}
                            selected={selector === 'month'}
                        >
                            <SelectorText selected={selector === 'month'}>
                                {displayMonth || 'Month'}
                            </SelectorText>
                            <Image
                                style={{
                                    cursor: 'pointer',
                                    transform:
                                        selector === 'month'
                                            ? 'rotate(180deg)'
                                            : 'rotate(0deg)',
                                    transitionDuration: '100ms',
                                }}
                                src={getImageBasePath('/icons/arrow.svg')}
                                width={'12px'}
                                height={'12px'}
                            />
                        </Selector>
                    </SelectorContainer>

                    <Container>
                        {selector === 'month' && months}

                        {selector === 'year' && years}
                    </Container>
                </>
            </div>
        </>
    );
};

export default YearMonthSelector;
